import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import OppsScreen from "../../src/LoanApproval/OppsScreen"
import LoanSuccess from "../../src/LoanApproval/SuccessScreen"
import CheckEligibility from "../pages/CheckEligibility";



const AppRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CheckEligibility />} />
        <Route path="/loan-reject" element={<OppsScreen />} />
        <Route path="/loan-success" element={<LoanSuccess />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
